import { location, navigate } from '../router/router.svelte';
import type { PageTourStep } from './steps';

export type TourEnd = 'finished' | 'skipped';

export interface StartOptions {
  orgId: string;
  /** Called once when the tour finishes (last «پایان») or is skipped. */
  onEnd?: (reason: TourEnd) => void;
}

/**
 * The in-page tour (employer request 2026-10-13): a list of steps, each on a real page. The
 * overlay (TourOverlay.svelte) walks to each page and explains it there. Only one tour runs.
 */
class Tour {
  steps = $state<PageTourStep[]>([]);
  index = $state(0);
  running = $state(false);
  orgId = '';
  private onEnd: ((reason: TourEnd) => void) | undefined;
  private origin = '';

  get current(): PageTourStep | undefined {
    return this.steps[this.index];
  }

  start(steps: PageTourStep[], options: StartOptions): void {
    if (steps.length === 0 || this.running) return;
    this.steps = steps;
    this.index = 0;
    this.orgId = options.orgId;
    this.onEnd = options.onEnd;
    this.origin = location.pathname + location.search;
    this.running = true;
  }

  next(): void {
    if (this.index >= this.steps.length - 1) this.end('finished');
    else this.index += 1;
  }

  back(): void {
    if (this.index > 0) this.index -= 1;
  }

  end(reason: TourEnd): void {
    if (!this.running) return;
    this.running = false;
    const onEnd = this.onEnd;
    this.onEnd = undefined;
    // The member comes back to where they started the tour.
    if (this.origin && this.origin !== location.pathname + location.search) navigate(this.origin);
    onEnd?.(reason);
  }
}

export const tour = new Tour();
